import {
    NOTIFICATIONS_SET_TEMPLATES,
    NOTIFICATIONS_ADD_TEMPLATE,
    RESET_BADGE_COUNT,
    NOTIFICATIONS_UPDATE_TEMPLATE,
    NOTIFICATIONS_REMOVE_TEMPLATE
} from '../actionTypes'

const defaultState = {
    badgeCount: 0,
    templates: {
        building: [],
    },
}

const notificationsReducer = (state = defaultState, action) => {
    switch (action.type) {
        case RESET_BADGE_COUNT:
            return {
                ...state,
                badgeCount: 0,
            }
        case NOTIFICATIONS_SET_TEMPLATES:
            return {
                ...state,
                templates: action.templates,
            }
        case NOTIFICATIONS_ADD_TEMPLATE:
            let _key = 'building'  // Default to building if no key found
            let _templates = { ...state.templates }  // Create a new copy of templates

            // Try to find the correct key
            Object.keys(_templates).forEach((key) => {
                const find = _templates[key].find((obj) => {
                    return obj.pk === action.id
                })
                if (find) _key = key
            })

            // Ensure the key exists and is an array
            if (!_templates[_key]) {
                _templates[_key] = []
            }

            _templates[_key] = [..._templates[_key], { ...action.template }]

            return {
                ...state,
                templates: _templates,
            }
        case NOTIFICATIONS_UPDATE_TEMPLATE:
            Object.keys(state.templates).forEach((key) => {
                const find = state.templates[key].find((obj) => {
                    return obj.pk === action.template.pk && obj.sk === action.template.sk
                })
                Object.assign(find, action.template)
            })

            return {
                ...state,
            }
        case NOTIFICATIONS_REMOVE_TEMPLATE:

            return {
                ...state,
                templates: Object.fromEntries(
                    Object.entries(state.templates).map(([key, value]) => {
                        if (Array.isArray(value)) {
                            return [key, value.filter(item => item.pk !== action.template.pk || item.sk !== action.template.sk)]
                        } else {
                            return [key, value]
                        }
                    })
                )
            }

        default:
            return state
    }
}

export default notificationsReducer
